<template>
    <div>
        <div style="margin-top:56px;" >
        <div class="container" style="margin-top:0px">
            
            
            <div class="row  lang-header">
                <div class="col-md-5" style="text-align: center;">
                  <img src="https://tsyyapi.dctechonline.cn/static/images/p2.jpg" class="home-img" style="opacity:0.8;width:90%;margin-bottom:5px;"/>
                </div>
                <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="step-box">
                          <div class="step-title">数据结构</div>
                          <div class="step-age"><div class="age">10-15岁</div></div>
                          <div class="step-desc">讲解编程中，常用的数据结构。适合有一定C++编程基础，想要在编程领域更进一步以及希望参加编程竞赛的同学</div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="step-box">
                          <div class="step-title">算法</div>
                          <div class="step-age"><div class="age">10-16岁</div></div>
                          <div class="step-desc">讲解编程中常用的基本算法，适合有一定C++编程基础，想要在编程领域更进一步以及希望参加编程竞赛的同学</div>
                        </div>
                      </div>

                     
                    </div>

                    <div style="text-align: center;margin-top:20px;"><button class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5"
                      @click="toClass()">进入课堂</button></div>
                </div>
            </div>
            
        </div>
    </div>


<div class="container">
     <div class="row" style="margin-top: 50px;">
        <div class="col-md-6" style="margin-bottom:20px">
          <h4 class="text-center mb-4">数据结构</h4>
          <ul class="list-group">
            <li class="list-group-item">第1节课：链表

            </li>
            <li class="list-group-item">第2节课：栈

            </li>
            <li class="list-group-item">第3节课：队列
               
            </li>
            <li class="list-group-item">第4节课：二叉树的概念
                
            </li>
            <li class="list-group-item">第5节课：二叉树的应用
                
            </li>
            
            <li class="list-group-item">第6节课：图的基本概念
                
            </li>
            <li class="list-group-item">第7节课：图的应用（一）
               
            </li>
            <li class="list-group-item">第8节课：图的应用（二）
               
              </li>
            <li class="list-group-item">第9节课：散列表和集合
                
            </li>

            <li class="list-group-item">第10节课：数据结构综合应用
                
            </li>
            
           
          </ul>
        </div>




        <div class="col-md-6" style="margin-bottom:20px">
          <h4 class="text-center mb-4">算法</h4>
          <ul class="list-group">
            
            <li class="list-group-item">第1节课：时间复杂度与进制转换
              
            </li>
            <li class="list-group-item">第2节课：查找算法
               
            </li>
            <li class="list-group-item">第3节课：枚举法，递推法
                
            </li>
            <li class="list-group-item">第4节课：简单排序算法
                
            </li>
            <li class="list-group-item">第5节课：贪心算法
                
            </li>
            <li class="list-group-item">第6节课：回溯算法

            </li>
            <li class="list-group-item">第7节课：分治算法：快速排序与归并排序
               
            </li>
            <li class="list-group-item">第8节课：动态规划算法
               
            </li>
            <li class="list-group-item">第9节课：算法中的编码与数学知识
               
            </li>
            <li class="list-group-item">第10节课：算法的综合运用
               
            </li>
         
          </ul>
        </div>
      </div>

   

      <div class="row mt-5">
        
        <div class="col-md-7">
          <h3 style="margin:20px 0px">教学师资</h3>
            <p style="text-align: left;">团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。</p>
            <p style="text-align: left;">首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。</p>
        </div>

        <div class="col-md-5">
          <img src="/images/teach.jpg" class="img-fluid" alt="Processing编程教室">
        </div>
      </div>

      <hr/>

      <div class="row" style="margin-top:50px;margin-bottom:50px;">
        <div class="col-md-7">
            <img src="/images/back2.jpg" class="img-fluid" alt="Processing编程教室"></img>

        </div>
        <div class="col-md-5">
            <h3 style="margin:20px 0px">我要上课</h3>
            
            <div style="margin-bottom:20px">联系课程顾问获取课程价格以及上课方式</div>
            <div><img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="max-width:180px"/></div>
        </div>
      </div>
    </div>
    <bottom></bottom>
</div>
</template>
<script>
import bottom from '@/components/bottom.vue'
export default{
    components:{
        bottom
    },
    methods:{
        toClass(){
            this.$router.push('/algorithm-class')
        }
    }
}
</script>
    
<style>
.sub{
    list-style: none;
    color:#666;
    font-weight: normal;
    margin-top:5px;
}
</style>